import { useEffect } from 'react';

/** Retry `loadFont` once the font catalog arrives (or the selected id changes). */
export function useRetrySelectedFontLoad(
  selectedSubtitleFontId: string,
  loadFont: (fontId: string) => void,
  myFonts: unknown,
): void {
  useEffect(() => {
    if (selectedSubtitleFontId) loadFont(selectedSubtitleFontId);
  }, [myFonts, selectedSubtitleFontId, loadFont]);
}
